import { CATEGORIES } from '~/constants/categories'

export const PLP_ROOT_META_DESCRIPTION = 'Shop Thorne supplements and at-home tests.'
export const PLP_TESTS_META_DESCRIPTION = 'Shop at-home tests and health panels from Thorne.'
export const PLP_BUNDLES_META_DESCRIPTION = 'Shop Thorne Product Stacks.'

function slugPath(slug: string | string[] | null | undefined): string {
  if (!slug) {
    return ''
  }
  return Array.isArray(slug) ? slug.filter(Boolean).join('/') : slug
}

function lastSlugSegment(path: string): string {
  return path.split('/').filter(Boolean).at(-1) ?? ''
}

function slugToLabel(path: string): string {
  const last = lastSlugSegment(path)
  if (!last) {
    return ''
  }
  const decoded = decodeURIComponent(last.replaceAll('+', ' '))
  return decoded
    .replaceAll('-', ' ')
    .replace(/\w\S*/g, (word) => word.charAt(0).toUpperCase() + word.substring(1).toLowerCase())
}

function findCategory(path: string) {
  const last = lastSlugSegment(path)
  return (
    CATEGORIES.find((cat) => cat.urlKey === path) ||
    (last ? CATEGORIES.find((cat) => cat.urlKey.endsWith(`/${last}`)) : undefined)
  )
}

export function shopFromThorne(phrase: string): string {
  const trimmed = phrase.trim()
  if (!trimmed) {
    return PLP_ROOT_META_DESCRIPTION
  }
  // Avoid "Shop Thorne X from Thorne." when the heading already includes the brand.
  if (/^thorne\b/i.test(trimmed)) {
    return `Shop ${trimmed}.`
  }
  return `Shop ${trimmed} from Thorne.`
}

/**
 * Unique PLP meta description from existing category heading or URL slug.
 * Root and tests pages have dedicated sentences so the tag is never empty.
 */
export function resolvePlpMetaDescription(input: {
  path: string
  slug?: string | string[] | null
  isBundles?: boolean
}): string {
  if (input.path.startsWith('/tests')) {
    return PLP_TESTS_META_DESCRIPTION
  }

  if (input.isBundles) {
    return PLP_BUNDLES_META_DESCRIPTION
  }

  const path = slugPath(input.slug)
  if (!path) {
    return PLP_ROOT_META_DESCRIPTION
  }

  const category = findCategory(path)
  const heading = category?.heading?.trim()
  if (heading) {
    return shopFromThorne(heading)
  }

  const label = slugToLabel(path)
  if (label) {
    return shopFromThorne(`${label} supplements`)
  }

  return PLP_ROOT_META_DESCRIPTION
}
